// Mind2Magic CRM — Typeform Import Module
// Extracted from index.html Step 9.

import { STAGES, TF_TAG_MAP, TF_STAGE_ORDER, TF_FORM_TYPES } from '../constants.js'
import { store } from '../store.js'

let tfImportData = null // { headers, rows, colMap, mappedLeads }



// ========== FORM TYPE DETECTION ==========

function detectTfFormType(headers) {
    const n = headers.length
    const h = headers.map(c => (c || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))

    // Use UNIQUE markers per form + column count for reliability.
    // Parques (46 cols): col 13 header contains "dias de parque de disney"
    if (h.some(c => c.includes('dias de parque de disney') || c.includes('dias de parque de universal')))
        return 'parques'

    // Cruceros (42 cols): has "zarpar" or "naviera" in headers
    if (h.some(c => c.includes('zarpar') || c.includes('naviera')))
        return 'cruceros'

    // Explorando (22 cols): exact checkbox headers
    if (h.some(c => c === 'parques de disney') || h.some(c => c === 'parques de universal'))
        return 'explorando'

    // Hoteles (24 cols): has "last name" and "phone number" (English headers unique to this form)
    if (h.some(c => c === 'last name') || h.some(c => c === 'phone number'))
        return 'hoteles'

    // Fallback: broader checks
    if (n >= 40 && h.join(' ').includes('dias de parque')) return 'parques'
    if (n >= 38 && h.join(' ').includes('crucero')) return 'cruceros'
    if (n <= 26 && h.join(' ').includes('alojamiento') && !h.join(' ').includes('dias de parque')) return 'hoteles'

    return null // Unknown — show selector
}

// ========== CRUCEROS MAPPER ==========
function detectTfColumnsCruceros(headers) {
    const map = {}
    const h = headers.map(c => (c || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
    for (let i = 0; i < h.length; i++) {
        const col = h[i]
        // Skip T&C / policy columns
        if (col.includes('terminos y condiciones') || col.includes('*terminos')) continue
        if (col.includes('nombre completo') && !map.titular) map.titular = i
        else if (col.includes('whatsapp') && !col.includes('confirmemos') && !map.phone) map.phone = i
        else if (col.includes('confirmemos') && col.includes('whatsapp') && !map.phoneConfirm) map.phoneConfirm = i
        else if (col.includes('email') && !map.email) map.email = i
        // Ports (multi-select columns)
        else if (col.includes('miami')) map.portMiami = i
        else if (col.includes('fort lauderdale')) map.portFtLauderdale = i
        else if (col.includes('orlando') || col.includes('canaveral')) map.portOrlando = i
        else if (col.includes('panama')) map.portPanama = i
        else if (col.includes('cartagena')) map.portCartagena = i
        else if (col.includes('no tengo preferencia') && !map.portNoPreference) map.portNoPreference = i
        // Destinations (multi-select)
        else if (col.includes('caribe') && !map.destCaribe) map.destCaribe = i
        else if (col.includes('mediterraneo') && !map.destMediterraneo) map.destMediterraneo = i
        else if (col.includes('europa') || col.includes('fiordos')) { if (!map.destEuropa) map.destEuropa = i }
        else if (col.includes('alaska') && !map.destAlaska) map.destAlaska = i
        else if (col.includes('sudamerica') && !map.destSudamerica) map.destSudamerica = i
        // Cruise details
        else if (col.includes('noches') && col.includes('crucero') && !map.nights) map.nights = i
        else if (col.includes('quien viajarias') && !map.travelWith) map.travelWith = i
        else if (col.includes('tipo de experiencia') && !map.experienceType) map.experienceType = i
        else if (col.includes('naviera') && !map.naviera) map.naviera = i
        else if (col.includes('fecha') && (col.includes('estimad') || col.includes('mes')) && !map.travelDate) map.travelDate = i
        else if (col.includes('cuando') && col.includes('zarpar') && !map.travelUrgency) map.travelUrgency = i
        else if (col.includes('cuantas personas') && !map.numTravelers) map.numTravelers = i
        else if (col.includes('menores') && !map.minors) map.minors = i
        else if (col.includes('distribuir') || col.includes('cabinas') || col.includes('especifica como')) { if (!map.cabinDistribution) map.cabinDistribution = i }
        else if (col.includes('residente') && !map.isResident) map.isResident = i
        else if (col.includes('presupuesto') && !map.budget) map.budget = i
        else if ((col.includes('importante') || col.includes('algo mas')) && !col.includes('terminos') && !map.notes) map.notes = i
        else if (col.includes('enteraste') && !map.source) map.source = i
        else if (col === 'tags' && !map.tags) map.tags = i
        else if (col.includes('submit date') && !map.submittedAt) map.submittedAt = i
        else if (col.includes('response type') && !map.responseType) map.responseType = i
    }
    return map
}

function mapTfRowsCruceros(rows, colMap) {
    return rows.map((row, idx) => {
        const rawTag = colMap.tags !== undefined ? String(row[colMap.tags] || '').trim() : ''
        const tagMapping = TF_TAG_MAP[rawTag] || { stage: 'nuevo', followUps: 0 }

        const titular = colMap.titular !== undefined ? String(row[colMap.titular] || '').trim() : ''
        const phone = colMap.phone !== undefined ? window.normalizePhone(row[colMap.phone]) : null
        const email = colMap.email !== undefined ? String(row[colMap.email] || '').trim() : ''
        const travelDate = colMap.travelDate !== undefined ? window.parseExcelDate(row[colMap.travelDate]) : null
        const submittedAt = colMap.submittedAt !== undefined ? window.parseExcelDate(row[colMap.submittedAt]) : null
        const sourceVal = colMap.source !== undefined ? String(row[colMap.source] || '') : ''

        // Collect ports
        const ports = []
        ;['portMiami','portFtLauderdale','portOrlando','portPanama','portCartagena','portNoPreference'].forEach(k => {
            if (colMap[k] !== undefined && row[colMap[k]] && String(row[colMap[k]]) !== 'nan') ports.push(String(row[colMap[k]]).replace(/\s*[🇺🇸🇵🇦🇨🇴]/g, '').trim())
        })

        // Collect destinations
        const destinations = []
        ;['destCaribe','destMediterraneo','destEuropa','destAlaska','destSudamerica'].forEach(k => {
            if (colMap[k] !== undefined && row[colMap[k]] && String(row[colMap[k]]) !== 'nan') destinations.push(String(row[colMap[k]]).replace(/\s*[🏝️🌅❄️🐋🌎]/g, '').trim())
        })

        const formData = {
            puertos: ports,
            destinos: destinations,
            noches: colMap.nights !== undefined ? String(row[colMap.nights] || '') : '',
            conQuien: colMap.travelWith !== undefined ? String(row[colMap.travelWith] || '') : '',
            experiencia: colMap.experienceType !== undefined ? String(row[colMap.experienceType] || '') : '',
            naviera: colMap.naviera !== undefined ? String(row[colMap.naviera] || '') : '',
            cuandoZarpar: colMap.travelUrgency !== undefined ? String(row[colMap.travelUrgency] || '') : '',
            viajeros: colMap.numTravelers !== undefined ? String(row[colMap.numTravelers] || '') : '',
            menores: colMap.minors !== undefined ? String(row[colMap.minors] || '') : '',
            cabinas: colMap.cabinDistribution !== undefined ? String(row[colMap.cabinDistribution] || '') : '',
            residente: colMap.isResident !== undefined ? String(row[colMap.isResident] || '') : '',
            presupuesto: colMap.budget !== undefined ? String(row[colMap.budget] || '') : '',
            notas: colMap.notes !== undefined ? String(row[colMap.notes] || '') : ''
        }

        // Build readable observaciones
        const obs = []
        if (ports.length) obs.push('Puertos: ' + ports.join(', '))
        if (destinations.length) obs.push('Destinos: ' + destinations.join(', '))
        if (formData.noches) obs.push('Noches: ' + formData.noches)
        if (formData.conQuien) obs.push('Viaja con: ' + formData.conQuien)
        if (formData.naviera) obs.push('Naviera: ' + formData.naviera)
        if (formData.viajeros) obs.push('Viajeros: ' + formData.viajeros)
        if (formData.menores) obs.push('Menores: ' + formData.menores)
        if (formData.presupuesto) obs.push('Presupuesto: ' + formData.presupuesto)
        if (formData.residente) obs.push('Residente FL/CA: ' + formData.residente)
        if (formData.notas) obs.push('Notas: ' + formData.notas)
        if (tagMapping.note) obs.push('Nota: ' + tagMapping.note)

        const destination = destinations.length ? destinations.join(', ') : 'Crucero'

        return {
            _index: idx, titular, phone, email, travelDate, destination,
            type: 'crucero', rawTag, stage: tagMapping.stage,
            followUps: tagMapping.followUps, lostReason: tagMapping.lostReason || null,
            observaciones: obs.join('\n'), formData, source: sourceVal, submittedAt,
            status: tagMapping.stage === 'skip' ? 'skip' : ((tagMapping.stage === 'perdido' || tagMapping.stage === 'no_compro') ? 'lost' : (!titular ? 'incomplete' : 'new')),
            selected: tagMapping.stage !== 'skip', duplicate: null, resolved: false
        }
    })
}

// ========== HOTELES MAPPER ==========
function detectTfColumnsHoteles(headers) {
    const map = {}
    const h = headers.map(c => (c || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
    for (let i = 0; i < h.length; i++) {
        const col = h[i]
        // Skip T&C / policy columns
        if (col.includes('terminos y condiciones') || col.includes('*terminos')) continue
        if (col.includes('nombre completo') && !map.titular) map.titular = i
        else if (col === 'last name' && !map.lastName) map.lastName = i
        else if (col === 'phone number' && !map.phone) map.phone = i
        else if (col === 'email' && !map.email) map.email = i
        else if ((col.includes('donde estas planeando') || col.includes('alojamiento')) && col.length < 200 && !col.includes('terminos') && !col.includes('politica')) { if (!map.destino) map.destino = i }
        else if (col.includes('fecha del viaje') && !map.dateType) map.dateType = i
        else if (col.includes('rango de fechas') && !map.dateRange) map.dateRange = i
        else if (col.includes('cuando planeas viajar') && !map.travelDate) map.travelDate = i
        else if (col.includes('noches') && !map.nights) map.nights = i
        else if (col.includes('requerimiento especial') && !map.specialReq) map.specialReq = i
        else if (col.includes('mas de una habitacion') && !map.multiRoom) map.multiRoom = i
        else if (col.includes('cuantas personas') && !map.travelers) map.travelers = i
        else if (col.includes('enteraste') && !map.source) map.source = i
        else if (col === 'tags' && !map.tags) map.tags = i
        else if (col.includes('submit date') && !map.submittedAt) map.submittedAt = i
        else if (col.includes('response type') && !map.responseType) map.responseType = i
    }
    return map
}

function mapTfRowsHoteles(rows, colMap) {
    return rows.map((row, idx) => {
        const rawTag = colMap.tags !== undefined ? String(row[colMap.tags] || '').trim() : ''
        const tagMapping = TF_TAG_MAP[rawTag] || { stage: 'nuevo', followUps: 0 }

        let titular = colMap.titular !== undefined ? String(row[colMap.titular] || '').trim() : ''
        if (colMap.lastName !== undefined && row[colMap.lastName]) titular += ' ' + String(row[colMap.lastName]).trim()
        titular = titular.trim()

        const phone = colMap.phone !== undefined ? window.normalizePhone(row[colMap.phone]) : null
        const email = colMap.email !== undefined ? String(row[colMap.email] || '').trim() : ''
        const travelDate = colMap.travelDate !== undefined ? window.parseExcelDate(row[colMap.travelDate]) : null
        const submittedAt = colMap.submittedAt !== undefined ? window.parseExcelDate(row[colMap.submittedAt]) : null
        const sourceVal = colMap.source !== undefined ? String(row[colMap.source] || '') : ''

        const formData = {
            destino: colMap.destino !== undefined ? String(row[colMap.destino] || '') : '',
            tipoFecha: colMap.dateType !== undefined ? String(row[colMap.dateType] || '') : '',
            rangoFechas: colMap.dateRange !== undefined ? String(row[colMap.dateRange] || '') : '',
            noches: colMap.nights !== undefined ? String(row[colMap.nights] || '') : '',
            requerimientoEspecial: colMap.specialReq !== undefined ? String(row[colMap.specialReq] || '') : '',
            variasHabitaciones: colMap.multiRoom !== undefined ? (row[colMap.multiRoom] == 1 ? 'Sí' : 'No') : '',
            viajeros: colMap.travelers !== undefined ? String(row[colMap.travelers] || '') : ''
        }

        const obs = []
        if (formData.destino) obs.push('Destino: ' + formData.destino)
        if (formData.noches) obs.push('Noches: ' + formData.noches)
        if (formData.tipoFecha) obs.push('Fecha: ' + formData.tipoFecha)
        if (formData.rangoFechas) obs.push('Rango: ' + formData.rangoFechas)
        if (formData.requerimientoEspecial) obs.push('Req. especial: ' + formData.requerimientoEspecial)
        if (formData.variasHabitaciones === 'Sí') obs.push('Varias habitaciones: Sí')
        if (formData.viajeros) obs.push('Viajeros: ' + formData.viajeros)
        if (tagMapping.note) obs.push('Nota: ' + tagMapping.note)

        const destination = formData.destino || 'Hotel'

        return {
            _index: idx, titular, phone, email, travelDate, destination,
            type: 'hotel', rawTag, stage: tagMapping.stage,
            followUps: tagMapping.followUps, lostReason: tagMapping.lostReason || null,
            observaciones: obs.join('\n'), formData, source: sourceVal, submittedAt,
            status: tagMapping.stage === 'skip' ? 'skip' : ((tagMapping.stage === 'perdido' || tagMapping.stage === 'no_compro') ? 'lost' : (!titular ? 'incomplete' : 'new')),
            selected: tagMapping.stage !== 'skip', duplicate: null, resolved: false
        }
    })
}

// ========== EXPLORANDO MAPPER ==========
function detectTfColumnsExplorando(headers) {
    const map = {}
    const h = headers.map(c => (c || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
    for (let i = 0; i < h.length; i++) {
        const col = h[i]
        // Skip T&C / policy columns
        if (col.includes('terminos y condiciones') || col.includes('*terminos')) continue
        if (col === 'parques de disney' && !map.interestDisney) map.interestDisney = i
        else if (col === 'parques de universal' && !map.interestUniversal) map.interestUniversal = i
        else if (col === 'cruceros' && !map.interestCruceros) map.interestCruceros = i
        else if (col === 'other' && !map.interestOther) map.interestOther = i
        else if (col.includes('cuando') && col.includes('viajar') && !map.travelWhen) map.travelWhen = i
        else if (col.includes('nombre completo') && !map.titular) map.titular = i
        else if (col.includes('whatsapp') && !col.includes('confirmemos') && !map.phone) map.phone = i
        else if (col.includes('email') && !map.email) map.email = i
        else if ((col.includes('importante') || col.includes('algo mas')) && !col.includes('terminos') && !map.notes) map.notes = i
        else if (col.includes('enteraste') && !map.source) map.source = i
        else if (col === 'tags' && !map.tags) map.tags = i
        else if (col.includes('submit date') && !map.submittedAt) map.submittedAt = i
        else if (col.includes('response type') && !map.responseType) map.responseType = i
    }
    return map
}

function mapTfRowsExplorando(rows, colMap) {
    return rows.map((row, idx) => {
        const rawTag = colMap.tags !== undefined ? String(row[colMap.tags] || '').trim() : ''
        const tagMapping = TF_TAG_MAP[rawTag] || { stage: 'nuevo', followUps: 0 }

        const titular = colMap.titular !== undefined ? String(row[colMap.titular] || '').trim() : ''
        const phone = colMap.phone !== undefined ? window.normalizePhone(row[colMap.phone]) : null
        const email = colMap.email !== undefined ? String(row[colMap.email] || '').trim() : ''
        const submittedAt = colMap.submittedAt !== undefined ? window.parseExcelDate(row[colMap.submittedAt]) : null
        const sourceVal = colMap.source !== undefined ? String(row[colMap.source] || '') : ''

        // Collect interests
        const interests = []
        if (colMap.interestDisney !== undefined && row[colMap.interestDisney] && String(row[colMap.interestDisney]) !== 'nan') interests.push('Parques Disney')
        if (colMap.interestUniversal !== undefined && row[colMap.interestUniversal] && String(row[colMap.interestUniversal]) !== 'nan') interests.push('Parques Universal')
        if (colMap.interestCruceros !== undefined && row[colMap.interestCruceros] && String(row[colMap.interestCruceros]) !== 'nan') interests.push('Cruceros')
        if (colMap.interestOther !== undefined && row[colMap.interestOther] && String(row[colMap.interestOther]) !== 'nan') interests.push(String(row[colMap.interestOther]))

        const travelWhen = colMap.travelWhen !== undefined ? String(row[colMap.travelWhen] || '') : ''
        const notes = colMap.notes !== undefined ? String(row[colMap.notes] || '') : ''

        const formData = {
            intereses: interests,
            cuandoViajar: travelWhen,
            notas: notes
        }

        const obs = []
        if (interests.length) obs.push('Intereses: ' + interests.join(', '))
        if (travelWhen) obs.push('Cuando: ' + travelWhen)
        if (notes) obs.push('Notas: ' + notes)
        if (tagMapping.note) obs.push('Nota: ' + tagMapping.note)

        // Determine type from interests
        let type = 'explorando'
        let destination = interests.join(' + ') || 'Explorando'

        return {
            _index: idx, titular, phone, email, travelDate: null, destination,
            type, rawTag, stage: tagMapping.stage,
            followUps: tagMapping.followUps, lostReason: tagMapping.lostReason || null,
            observaciones: obs.join('\n'), formData, source: sourceVal, submittedAt,
            status: tagMapping.stage === 'skip' ? 'skip' : ((tagMapping.stage === 'perdido' || tagMapping.stage === 'no_compro') ? 'lost' : (!titular ? 'incomplete' : 'new')),
            selected: tagMapping.stage !== 'skip', duplicate: null, resolved: false
        }
    })
}

function detectTfColumns(headers) {
    const map = {}
    map.hotelTypes = []
    map.universalParks = []
    const h = headers.map(h => (h || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))

    for (let i = 0; i < h.length; i++) {
        const col = h[i]
        // Skip T&C / policy columns
        if (col.includes('terminos y condiciones') || col.includes('*terminos')) continue
        if (col.includes('nombre completo') && !map.titular) map.titular = i
        else if (col.includes('whatsapp') && !col.includes('confirmemos') && !map.phone) map.phone = i
        else if (col.includes('confirmemos') && col.includes('whatsapp') && !map.phoneConfirm) map.phoneConfirm = i
        else if (col.includes('email') && !map.email) map.email = i
        else if (col.includes('fecha') && (col.includes('estimad') || col.includes('viajar')) && !map.travelDate) map.travelDate = i
        else if (col.includes('cuando') && col.includes('viajar') && !map.travelUrgency) map.travelUrgency = i
        else if (col.includes('personas viajan') && !map.numTravelers) map.numTravelers = i
        else if (col.includes('menores') && col.includes('edades') && !map.minorAges) map.minorAges = i
        else if (col.includes('menores') && !map.minors) map.minors = i
        else if (col.includes('distribuir') || (col.includes('grupo') && col.includes('habitacion'))) { if (!map.roomDistribution) map.roomDistribution = i }
        else if (col.includes('residente') && !map.isFloridaResident) map.isFloridaResident = i
        else if (col.includes('dias de parque de disney') || (col.includes('numero de dias') && col.includes('disney'))) { if (!map.disneyDays) map.disneyDays = i }
        else if (col.includes('dias de parque de universal') || (col.includes('numero de dias') && col.includes('universal'))) { if (!map.universalDays) map.universalDays = i }
        // Universal park type checkboxes (individual parks)
        else if ((col === 'universal studios' || col === 'island of adventure' || col === 'epic universe'
            || col.includes('todos los parques de universal'))) { map.universalParks.push({ idx: i, label: headers[i] }) }
        else if (col.includes('hotel') && col.includes('deseas hospedar') && !map.hotelPreference) map.hotelPreference = i
        // Hotel type checkboxes (individual hotel options)
        else if ((col.startsWith('hotel ') || col.includes('hotel universal') || col.includes('helios hotel')) && !col.includes('deseas hospedar')) { map.hotelTypes.push({ idx: i, label: headers[i] }) }
        else if (col.includes('noches') && !map.nights) map.nights = i
        else if (col.includes('experiencias') && !map.experiences) map.experiences = i
        else if (col.includes('presupuesto') && !map.budget) map.budget = i
        else if (col.includes('evento especial') && !map.specialEvent) map.specialEvent = i
        else if ((col.includes('importante') || col.includes('algo mas')) && !col.includes('terminos') && !map.notes) map.notes = i
        else if (col.includes('enteraste') && !map.source) map.source = i
        else if (col.includes('documentos necesarios') && !map.hasDocuments) map.hasDocuments = i
        else if (col.includes('tiquetes') && !map.hasFlights) map.hasFlights = i
        else if (col === 'tags' && !map.tags) map.tags = i
        else if (col.includes('submit date') && !map.submittedAt) map.submittedAt = i
        else if (col.includes('response type') && !map.responseType) map.responseType = i
    }
    return map
}

function mapTfRows(rows, colMap) {
    return rows.map((row, idx) => {
        const rawTag = colMap.tags !== undefined ? String(row[colMap.tags] || '').trim() : ''
        const tagMapping = TF_TAG_MAP[rawTag] || { stage: 'nuevo', followUps: 0 }

        const titular = colMap.titular !== undefined ? String(row[colMap.titular] || '').trim() : ''
        const phone = colMap.phone !== undefined ? window.normalizePhone(row[colMap.phone]) : null
        const email = colMap.email !== undefined ? String(row[colMap.email] || '').trim() : ''
        const travelDate = colMap.travelDate !== undefined ? window.parseExcelDate(row[colMap.travelDate]) : null

        // Build observaciones from extra fields
        const obs = []
        if (colMap.numTravelers !== undefined && row[colMap.numTravelers]) obs.push('Viajeros: ' + row[colMap.numTravelers])
        // Ages: prefer minorAges column, fallback to minors
        const agesCol = colMap.minorAges !== undefined ? colMap.minorAges : colMap.minors
        if (agesCol !== undefined && row[agesCol]) obs.push('Edades menores: ' + row[agesCol])
        if (colMap.roomDistribution !== undefined && row[colMap.roomDistribution]) obs.push('Habitaciones: ' + row[colMap.roomDistribution])
        // Disney days: strip reminder text after number (e.g. "2 (Recuerda que...)" → "2")
        const rawDisneyDays = colMap.disneyDays !== undefined ? String(row[colMap.disneyDays] || '') : ''
        const cleanDisneyDays = rawDisneyDays.replace(/\s*\(.*$/, '').trim()
        if (cleanDisneyDays) obs.push('Días Disney: ' + cleanDisneyDays)
        const rawUnivDays = colMap.universalDays !== undefined ? String(row[colMap.universalDays] || '') : ''
        const cleanUnivDays = rawUnivDays.toLowerCase().includes('no ire a universal') ? '' : rawUnivDays.replace(/\s*\(.*$/, '').trim()
        if (cleanUnivDays) obs.push('Días Universal: ' + cleanUnivDays)
        // Universal park types (checkboxes)
        if (colMap.universalParks && colMap.universalParks.length) {
            const selParks = colMap.universalParks.filter(p => row[p.idx] && String(row[p.idx]) !== 'nan').map(p => p.label)
            if (selParks.length) obs.push('Parques Universal: ' + selParks.join(', '))
        }
        if (colMap.hotelPreference !== undefined && row[colMap.hotelPreference] && String(row[colMap.hotelPreference]).toLowerCase() !== 'no') obs.push('Hotel preferido: ' + row[colMap.hotelPreference])
        // Hotel type selections (checkboxes)
        if (colMap.hotelTypes && colMap.hotelTypes.length) {
            const selHotels = colMap.hotelTypes.filter(h => row[h.idx] && String(row[h.idx]) !== 'nan').map(h => h.label)
            if (selHotels.length) obs.push('Tipo hotel: ' + selHotels.join(', '))
        }
        if (colMap.nights !== undefined && row[colMap.nights]) obs.push('Noches: ' + row[colMap.nights])
        if (colMap.budget !== undefined && row[colMap.budget]) obs.push('Presupuesto: ' + row[colMap.budget])
        if (colMap.specialEvent !== undefined && row[colMap.specialEvent]) obs.push('Evento: ' + row[colMap.specialEvent])
        if (colMap.notes !== undefined && row[colMap.notes]) obs.push('Notas: ' + row[colMap.notes])
        if (colMap.experiences !== undefined && row[colMap.experiences]) obs.push('Experiencias: ' + row[colMap.experiences])
        if (colMap.hasDocuments !== undefined && row[colMap.hasDocuments]) obs.push('Documentos: ' + row[colMap.hasDocuments])
        if (colMap.hasFlights !== undefined && row[colMap.hasFlights]) obs.push('Tiquetes: ' + row[colMap.hasFlights])
        if (colMap.isFloridaResident !== undefined && row[colMap.isFloridaResident]) obs.push('Residente FL: ' + row[colMap.isFloridaResident])
        if (tagMapping.note) obs.push('Nota: ' + tagMapping.note)

        const sourceVal = colMap.source !== undefined ? String(row[colMap.source] || '') : ''
        const submittedAt = colMap.submittedAt !== undefined ? window.parseExcelDate(row[colMap.submittedAt]) : null

        // Determine destination based on available data
        let destination = 'Disney World'
        if (cleanUnivDays) {
            destination = 'Disney + Universal'
        }

        // Build structured formData (matches Cruceros/Hoteles/Explorando pattern)
        const numTrav = colMap.numTravelers !== undefined ? String(row[colMap.numTravelers] || '') : ''
        const agesVal = agesCol !== undefined ? String(row[agesCol] || '') : ''
        const selHotelTypes = (colMap.hotelTypes || []).filter(h => row[h.idx] && String(row[h.idx]) !== 'nan').map(h => h.label)
        const selUnivParks = (colMap.universalParks || []).filter(p => row[p.idx] && String(row[p.idx]) !== 'nan').map(p => p.label)
        const formData = {
            viajeros: numTrav,
            edadesMenores: agesVal,
            habitaciones: colMap.roomDistribution !== undefined ? String(row[colMap.roomDistribution] || '') : '',
            diasDisney: cleanDisneyDays,
            diasUniversal: cleanUnivDays,
            parquesUniversal: selUnivParks.join(', '),
            hotel: colMap.hotelPreference !== undefined ? String(row[colMap.hotelPreference] || '') : '',
            tipoHotel: selHotelTypes.join(', '),
            noches: colMap.nights !== undefined ? String(row[colMap.nights] || '') : '',
            presupuesto: colMap.budget !== undefined ? String(row[colMap.budget] || '') : '',
            eventoEspecial: colMap.specialEvent !== undefined ? String(row[colMap.specialEvent] || '') : '',
            experiencias: colMap.experiences !== undefined ? String(row[colMap.experiences] || '') : '',
            documentos: colMap.hasDocuments !== undefined ? String(row[colMap.hasDocuments] || '') : '',
            tiquetes: colMap.hasFlights !== undefined ? String(row[colMap.hasFlights] || '') : '',
            residenteFL: colMap.isFloridaResident !== undefined ? String(row[colMap.isFloridaResident] || '') : '',
            fuente: sourceVal,
            notas: colMap.notes !== undefined ? String(row[colMap.notes] || '') : ''
        }

        // Build viajeros summary (e.g. "11 (edades menores: 8, 7, 5, 1 y 1)")
        let viajeros = ''
        if (numTrav) viajeros = numTrav + (agesVal ? ' (edades menores: ' + agesVal + ')' : '')

        // Extract diasParque
        const diasParque = parseInt(cleanDisneyDays) || 0

        return {
            _index: idx,
            titular,
            phone,
            email,
            travelDate,
            destination,
            type: 'disney',
            rawTag,
            stage: tagMapping.stage,
            followUps: tagMapping.followUps,
            lostReason: tagMapping.lostReason || null,
            observaciones: obs.join('\n'),
            formData,
            viajeros,
            diasParque: diasParque || null,
            source: sourceVal,
            submittedAt,
            // Import control
            status: tagMapping.stage === 'skip' ? 'skip' : ((tagMapping.stage === 'perdido' || tagMapping.stage === 'no_compro') ? 'lost' : (!titular ? 'incomplete' : 'new')),
            selected: tagMapping.stage !== 'skip',
            duplicate: null, // { existingLead, resolution }
            resolved: false
        }
    })
}

function detectTfDuplicates(mappedLeads) {
    const { leads, historico } = store
    const normName = (n) => n ? n.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim() : ''

    mappedLeads.forEach(ml => {
        if (ml.status === 'skip' || ml.status === 'incomplete') return
        const mlVal = parseFloat(ml.totalVenta) || 0

        // Helper: skip if both have prices and they differ (different sale)
        const pricesDiffer = (existing) => {
            const eVal = existing.totalVenta || 0
            return mlVal > 0 && eVal > 0 && mlVal !== eVal
        }

        // Check by phone + name
        let match = null
        if (ml.phone) {
            const norm = normName(ml.titular)
            const existingLead = leads.find(l => l.phone === ml.phone && normName(l.titular) === norm && !pricesDiffer(l))
                || historico.find(h => h.phone === ml.phone && normName(h.titular) === norm && !pricesDiffer(h))
            if (existingLead) match = existingLead
        }

        // Check by name if no phone match (also respect price difference)
        if (!match && ml.titular) {
            const norm = normName(ml.titular)
            if (norm.length >= 3) {
                match = leads.find(l => normName(l.titular) === norm && !pricesDiffer(l))
                    || historico.find(h => normName(h.titular) === norm && !pricesDiffer(h))
            }
        }

        if (match) {
            ml.status = 'duplicate'
            ml.duplicate = { existingLead: match, resolution: null }
        }
    })
}

function handleTypeformFile(event) {
    const file = event.target.files[0]
    if (!file) return
    if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
        window.toast('Selecciona un archivo Excel (.xlsx)', 'error')
        return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
        try {
            const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true })
            const ws = wb.Sheets[wb.SheetNames[0]]
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 })

            if (data.length < 2) { window.toast('El archivo está vacío', 'error'); return }

            const headers = data[0].map(h => String(h || ''))
            const rows = data.slice(1).filter(r => r.some(cell => cell != null && cell !== ''))

            // Auto-detect form type
            const formType = detectTfFormType(headers)
            console.log('DEBUG TF formType:', formType, 'headers:', headers.map((h,i) => i + ':' + String(h).substring(0,40)))

            // Store raw data for potential re-mapping if user selects different type
            tfImportData = { headers, rows, formType, colMap: null, mappedLeads: null }

            if (formType) {
                applyTfFormType(formType)
                showTfWizard(1)
            } else {
                // Show form type selector
                showTfFormTypeSelector()
            }
        } catch (err) {
            console.error('Typeform parse error:', err)
            window.toast('Error al leer el archivo: ' + err.message, 'error')
        }
    }
    reader.readAsBinaryString(file)
    event.target.value = ''
}

function applyTfFormType(formType) {
    const { headers, rows } = tfImportData
    let colMap, mappedLeads

    if (formType === 'cruceros') {
        colMap = detectTfColumnsCruceros(headers)
        mappedLeads = mapTfRowsCruceros(rows, colMap)
    } else if (formType === 'hoteles') {
        colMap = detectTfColumnsHoteles(headers)
        mappedLeads = mapTfRowsHoteles(rows, colMap)
    } else if (formType === 'explorando') {
        colMap = detectTfColumnsExplorando(headers)
        mappedLeads = mapTfRowsExplorando(rows, colMap)
    } else {
        // Default: parques (original mapper)
        colMap = detectTfColumns(headers)
        mappedLeads = mapTfRows(rows, colMap)
    }

    detectTfDuplicates(mappedLeads)
    tfImportData.formType = formType
    tfImportData.colMap = colMap
    tfImportData.mappedLeads = mappedLeads
}

function showTfFormTypeSelector() {
    let overlay = document.getElementById('tfWizardOverlay')
    if (!overlay) {
        overlay = document.createElement('div')
        overlay.className = 'tf-wizard-overlay'
        overlay.id = 'tfWizardOverlay'
        document.body.appendChild(overlay)
    }

    const types = Object.entries(TF_FORM_TYPES).map(([key, v]) =>
        `<button class="btn btn-secondary" style="padding:16px 24px;font-size:14px;display:flex;align-items:center;gap:8px;" onclick="selectTfFormType('${key}')">
            <span style="font-size:20px;">${v.icon}</span> ${v.label}
        </button>`
    ).join('')

    overlay.innerHTML = `
        <div class="tf-wizard" style="max-width:480px;">
            <div class="tf-wizard-header">
                <h3>Tipo de formulario</h3>
                <button class="tf-wizard-close" onclick="closeTfWizard()">×</button>
            </div>
            <div class="tf-wizard-body" style="text-align:center;">
                <p style="color:var(--text-2);font-size:13px;margin-bottom:20px;">No pudimos detectar el tipo de formulario automáticamente.<br>¿Qué tipo de formulario es?</p>
                <div style="display:flex;flex-direction:column;gap:10px;">${types}</div>
            </div>
        </div>`
}

function selectTfFormType(formType) {
    applyTfFormType(formType)
    showTfWizard(1)
}

function showTfWizard(step) {
    let overlay = document.getElementById('tfWizardOverlay')
    if (!overlay) {
        overlay = document.createElement('div')
        overlay.className = 'tf-wizard-overlay'
        overlay.id = 'tfWizardOverlay'
        document.body.appendChild(overlay)
    }

    const ml = tfImportData.mappedLeads
    const counts = {
        new: ml.filter(m => m.status === 'new' && m.selected).length,
        duplicate: ml.filter(m => m.status === 'duplicate' && m.selected).length,
        lost: ml.filter(m => m.status === 'lost' && m.selected).length,
        skip: ml.filter(m => m.status === 'skip').length,
        incomplete: ml.filter(m => m.status === 'incomplete').length,
        resolved: ml.filter(m => m.status === 'duplicate' && m.resolved).length,
        excluded: ml.filter(m => !m.selected && m.status !== 'skip').length
    }
    const unresolvedDups = counts.duplicate - counts.resolved

    const stepIndicator = `<div class="tf-steps">
        ${[1,2,3,4].map((s, i) => `<span class="tf-step ${s < step ? 'done' : (s === step ? 'active' : '')}">${s}</span>${i < 3 ? `<span class="tf-step-line ${s < step ? 'done' : ''}"></span>` : ''}`).join('')}
    </div>`

    let bodyHTML = ''
    let footerHTML = ''
    let title = ''

    if (step === 1) {
        title = 'Paso 1: Archivo cargado'
        const cm = tfImportData.colMap
        const ft = tfImportData.formType
        const ftInfo = TF_FORM_TYPES[ft] || { label: ft, icon: '📄' }

        const allFieldLabels = {
            titular: 'Nombre', lastName: 'Apellido', phone: 'WhatsApp', phoneConfirm: 'WhatsApp confirm', email: 'Email',
            travelDate: 'Fecha viaje', travelUrgency: 'Urgencia viaje', tags: 'Tags', numTravelers: 'Viajeros', minors: 'Menores',
            disneyDays: 'Dias Disney', universalDays: 'Dias Universal', budget: 'Presupuesto', source: 'Fuente', notes: 'Notas',
            hotelPreference: 'Hotel', nights: 'Noches', submittedAt: 'Fecha envío',
            // Cruceros
            portMiami: 'Puerto Miami', portFtLauderdale: 'Puerto Ft.Lauderdale', portOrlando: 'Puerto Orlando',
            portPanama: 'Puerto Panamá', portCartagena: 'Puerto Cartagena', naviera: 'Naviera',
            travelWith: 'Viaja con', experienceType: 'Experiencia', cabinDistribution: 'Cabinas', isResident: 'Residente FL/CA',
            destCaribe: 'Dest. Caribe', destMediterraneo: 'Dest. Mediterráneo', destEuropa: 'Dest. Europa', destAlaska: 'Dest. Alaska',
            // Hoteles
            destino: 'Destino', dateType: 'Tipo fecha', dateRange: 'Rango fechas', specialReq: 'Req. especial',
            multiRoom: 'Varias hab.', travelers: 'Viajeros',
            // Explorando
            interestDisney: 'Int. Disney', interestUniversal: 'Int. Universal', interestCruceros: 'Int. Cruceros', travelWhen: 'Cuando viaja'
        }
        const detected = Object.entries(cm).filter(([k]) => allFieldLabels[k]).map(([k, v]) => `<div class="tf-detected-item"><span class="tf-detected-label">${allFieldLabels[k]}</span><span class="tf-detected-val">Col ${v + 1}</span></div>`).join('')

        // Form type badge + change button
        const formTypeBadge = `<div style="display:flex;align-items:center;gap:12px;margin-bottom:16px;padding:12px 16px;background:rgba(67,97,238,0.08);border:1px solid rgba(67,97,238,0.2);border-radius:10px;">
            <span style="font-size:24px;">${ftInfo.icon}</span>
            <div><div style="font-size:14px;font-weight:600;color:var(--text-1);">Detectado: ${ftInfo.label}</div><div style="font-size:11px;color:var(--text-3);">${tfImportData.rows.length} respuestas, ${Object.keys(cm).length} columnas mapeadas</div></div>
            <button class="btn btn-xs btn-ghost" style="margin-left:auto;" onclick="showTfFormTypeSelector()">Cambiar</button>
        </div>`

        // Sample table (first 5 rows)
        const sampleCols = ['titular','phone','email','travelDate','tags'].filter(k => cm[k] !== undefined)
        const sampleHeaders = sampleCols.map(k => allFieldLabels[k] || k)
        const sampleRows = tfImportData.rows.slice(0, 5).map(r => `<tr>${sampleCols.map(k => `<td>${String(r[cm[k]] || '').substring(0, 40)}</td>`).join('')}</tr>`).join('')

        bodyHTML = `
            ${formTypeBadge}
            <h4 style="font-size:13px;margin-bottom:8px;">Columnas detectadas</h4>
            <div class="tf-detected">${detected}</div>
            <h4 style="font-size:13px;margin-bottom:8px;">Preview (5 primeras filas)</h4>
            <div style="overflow-x:auto;border:1px solid var(--border);border-radius:8px;">
                <table class="tf-sample-table"><thead><tr>${sampleHeaders.map(h => `<th>${h}</th>`).join('')}</tr></thead><tbody>${sampleRows}</tbody></table>
            </div>`
        footerHTML = `<button class="btn btn-secondary" onclick="closeTfWizard()">Cancelar</button><button class="btn btn-primary" onclick="showTfWizard(2)">Siguiente →</button>`

    } else if (step === 2) {
        title = 'Paso 2: Mapeo y Preview'
        const countBar = `<div class="tf-count-bar">
            <div class="tf-count-item"><span class="tf-dot green"></span> Nuevos: ${counts.new}</div>
            <div class="tf-count-item"><span class="tf-dot yellow"></span> Duplicados: ${counts.duplicate} ${counts.resolved > 0 ? `(${counts.resolved} resueltos)` : ''}</div>
            <div class="tf-count-item"><span class="tf-dot gray"></span> Perdidos: ${counts.lost}</div>
            <div class="tf-count-item"><span class="tf-dot red"></span> Incompletos: ${counts.incomplete}</div>
            ${counts.skip > 0 ? `<div class="tf-count-item">⬜ Skip: ${counts.skip}</div>` : ''}
        </div>`

        const bulkResolveBtn = unresolvedDups > 0 ? `<button class="btn btn-sm btn-primary" onclick="resolveAllDuplicates()" style="margin-left:auto;">🧠 Fusión Inteligente (${unresolvedDups} duplicados)</button>` : ''
        const selectAll = `<div class="tf-select-all" style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;"><div><input type="checkbox" id="tfSelectAll" onchange="tfToggleAll(this.checked)" ${ml.filter(m => m.status !== 'skip').every(m => m.selected) ? 'checked' : ''}> <label for="tfSelectAll">Seleccionar todos</label></div>${bulkResolveBtn}</div>`

        const tableRows = ml.map((m, i) => {
            const statusClass = m.status === 'skip' ? 'tf-row-skip' : (m.status === 'lost' ? 'tf-row-lost' : (!m.selected ? 'tf-row-excluded' : ''))
            const dotColor = m.status === 'new' ? 'green' : (m.status === 'duplicate' ? 'yellow' : (m.status === 'lost' ? 'gray' : (m.status === 'incomplete' ? 'red' : '')))
            const statusLabel = m.status === 'new' ? 'Nuevo' : (m.status === 'duplicate' ? (m.resolved ? 'Resuelto' : 'Duplicado') : (m.status === 'lost' ? (m.lostReason || 'Perdido') : (m.status === 'skip' ? 'Repetido' : 'Sin datos')))

            const stageOptions = [...STAGES.map(s => `<option value="${s.id}" ${m.stage === s.id ? 'selected' : ''}>${s.name}</option>`), `<option value="perdido" ${m.stage === 'perdido' ? 'selected' : ''}>Perdido (Histórico)</option>`].join('')

            const dupBtn = m.status === 'duplicate' && !m.resolved ? `<button class="btn btn-xs btn-warning" onclick="openTfDuplicateModal(${i})">Resolver</button>` : (m.resolved ? '<span style="color:var(--green);font-size:11px;">✓</span>' : '')

            const checkbox = m.status !== 'skip' ? `<input type="checkbox" ${m.selected ? 'checked' : ''} onchange="tfToggleRow(${i}, this.checked)">` : ''

            return `<tr class="${statusClass}" data-tf-idx="${i}">
                <td>${checkbox}</td>
                <td><div class="tf-status"><span class="tf-dot ${dotColor}"></span>${statusLabel}</div></td>
                <td style="font-weight:500;">${m.titular || '<em style="color:var(--red)">Sin nombre</em>'}</td>
                <td>${m.phone || '—'}</td>
                <td style="font-size:11px;">${m.rawTag || '—'}</td>
                <td><select class="tf-stage-select" onchange="tfChangeStage(${i}, this.value)">${stageOptions}</select></td>
                <td>${dupBtn}</td>
            </tr>`
        }).join('')

        bodyHTML = `${countBar}${selectAll}
            <div class="tf-table-wrap">
                <table class="tf-table">
                    <thead><tr><th style="width:30px;"></th><th>Estado</th><th>Nombre</th><th>Teléfono</th><th>Tag Typeform</th><th>Etapa CRM</th><th>Acción</th></tr></thead>
                    <tbody>${tableRows}</tbody>
                </table>
            </div>`

        const importCount = ml.filter(m => m.selected && m.status !== 'skip').length
        footerHTML = `<button class="btn btn-secondary" onclick="showTfWizard(1)">← Atrás</button>
            <div style="display:flex;gap:8px;align-items:center;">
                ${unresolvedDups > 0 ? `<span style="font-size:12px;color:var(--yellow);">${unresolvedDups} duplicado(s) sin resolver</span>` : ''}
                <button class="btn btn-primary" onclick="showTfWizard(3)" ${unresolvedDups > 0 ? 'disabled title="Resuelve todos los duplicados primero"' : ''}>Importar ${importCount} leads →</button>
            </div>`

    } else if (step === 3) {
        title = 'Paso 3: Confirmar importación'
        const selected = ml.filter(m => m.selected && m.status !== 'skip')
        const newCount = selected.filter(m => m.status === 'new').length
        const mergedCount = selected.filter(m => m.status === 'duplicate' && m.resolved && m.duplicate?.resolution !== 'keep_crm').length
        const keptCRM = selected.filter(m => m.status === 'duplicate' && m.resolved && m.duplicate?.resolution === 'keep_crm').length
        const lostCount = selected.filter(m => m.status === 'lost').length
        const skipCount = ml.filter(m => !m.selected || m.status === 'skip').length

        bodyHTML = `
            <div style="text-align:center;margin-bottom:24px;">
                <p style="color:var(--text-2);font-size:14px;">Verifica el resumen antes de importar:</p>
            </div>
            <div class="tf-summary-grid">
                <div class="tf-summary-card"><div class="tf-summary-val green">${newCount}</div><div class="tf-summary-label">Nuevos leads</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val yellow">${mergedCount}</div><div class="tf-summary-label">Fusionados/Actualizados</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val gray">${lostCount}</div><div class="tf-summary-label">Enviados a Histórico</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val red">${skipCount + keptCRM}</div><div class="tf-summary-label">Ignorados</div></div>
            </div>
            <div style="background:var(--bg-2);border-radius:10px;padding:16px;margin-top:16px;">
                <h4 style="font-size:13px;margin-bottom:12px;">Detalle por etapa</h4>
                ${(() => {
                    const byStage = {}
                    selected.filter(m => m.status !== 'lost').forEach(m => {
                        const sName = STAGES.find(s => s.id === m.stage)?.name || m.stage
                        byStage[sName] = (byStage[sName] || 0) + 1
                    })
                    return Object.entries(byStage).map(([name, count]) => `<div style="display:flex;justify-content:space-between;padding:4px 0;font-size:12px;border-bottom:1px solid var(--border);"><span>${name}</span><span style="font-weight:600;">${count}</span></div>`).join('')
                })()}
                ${lostCount > 0 ? `<div style="display:flex;justify-content:space-between;padding:4px 0;font-size:12px;"><span style="color:var(--text-3);">Histórico (perdidos)</span><span style="font-weight:600;color:var(--text-3);">${lostCount}</span></div>` : ''}
            </div>`
        footerHTML = `<button class="btn btn-secondary" onclick="showTfWizard(2)">← Atrás</button><button class="btn btn-success" onclick="executeTfImport()">Confirmar Importación</button>`

    } else if (step === 4) {
        title = 'Paso 4: Resultado'
        const results = tfImportData._results || { created: 0, merged: 0, lost: 0, skipped: 0, errors: 0, log: [] }
        bodyHTML = `
            <div style="text-align:center;margin-bottom:16px;">
                <div style="font-size:40px;margin-bottom:8px;">✅</div>
                <h3 style="font-size:18px;">Importación completada</h3>
            </div>
            <div class="tf-summary-grid">
                <div class="tf-summary-card"><div class="tf-summary-val green">${results.created}</div><div class="tf-summary-label">Creados</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val yellow">${results.merged}</div><div class="tf-summary-label">Fusionados</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val gray">${results.lost}</div><div class="tf-summary-label">Histórico</div></div>
                <div class="tf-summary-card"><div class="tf-summary-val red">${results.skipped}</div><div class="tf-summary-label">Ignorados</div></div>
            </div>
            <details style="margin-top:16px;">
                <summary style="cursor:pointer;font-size:13px;color:var(--text-2);padding:8px 0;">Ver log detallado (${results.log.length} acciones)</summary>
                <div class="tf-log">${results.log.map(entry => `<div class="tf-log-entry"><span class="log-action ${entry.action}">${entry.action === 'created' ? '✅' : entry.action === 'merged' ? '🔀' : entry.action === 'lost' ? '⚫' : '❌'}</span> ${entry.text}</div>`).join('')}</div>
            </details>`
        footerHTML = `<button class="btn btn-primary" onclick="closeTfWizard(); showView('pipeline');">Cerrar</button>`
    }

    overlay.innerHTML = `
        <div class="tf-wizard">
            <div class="tf-wizard-header">
                <h3>${title}</h3>
                <div style="display:flex;align-items:center;gap:16px;">${stepIndicator}<button class="tf-wizard-close" onclick="closeTfWizard()">×</button></div>
            </div>
            <div class="tf-wizard-body">${bodyHTML}</div>
            <div class="tf-wizard-footer">${footerHTML}</div>
        </div>`
}

function tfToggleAll(checked) {
    tfImportData.mappedLeads.forEach(m => { if (m.status !== 'skip') m.selected = checked })
    showTfWizard(2)
}

function tfToggleRow(idx, checked) {
    tfImportData.mappedLeads[idx].selected = checked
    showTfWizard(2)
}

function tfChangeStage(idx, newStage) {
    const m = tfImportData.mappedLeads[idx]
    m.stage = newStage
    if (newStage === 'perdido' || newStage === 'no_compro') {
        m.status = 'lost'
        m.lostReason = m.lostReason || (newStage === 'no_compro' ? 'No compró' : 'Reclasificado manualmente')
    } else if (m.status === 'lost' && newStage !== 'perdido' && newStage !== 'no_compro') {
        m.status = m.duplicate ? 'duplicate' : 'new'
        m.lostReason = null
    }
    // Don't re-render the whole wizard to avoid scroll reset — just update counts
}

function openTfDuplicateModal(idx) {
    const m = tfImportData.mappedLeads[idx]
    if (!m.duplicate) return
    const existing = m.duplicate.existingLead

    const existingStage = STAGES.find(s => s.id === existing.stage)?.name || existing.stage
    const tfStage = STAGES.find(s => s.id === m.stage)?.name || m.stage

    const fields = [
        { label: 'Nombre', tf: m.titular, crm: existing.titular },
        { label: 'Teléfono', tf: m.phone || '—', crm: existing.phone || '—' },
        { label: 'Email', tf: m.email || '—', crm: existing.email || '—' },
        { label: 'Destino', tf: m.destination || '—', crm: existing.destination || '—' },
        { label: 'Fecha viaje', tf: m.travelDate || '—', crm: existing.travelDate ? window.fmtDate(existing.travelDate) : '—' },
        { label: 'Etapa', tf: tfStage, crm: existingStage },
        { label: 'Seguimientos', tf: m.followUps || 0, crm: existing.seguimientos || 0 }
    ]

    const existingOrder = TF_STAGE_ORDER[existing.stage] || 0
    const tfOrder = TF_STAGE_ORDER[m.stage] || 0
    const moreAdvanced = existingOrder >= tfOrder ? 'CRM' : 'Typeform'

    const modal = document.createElement('div')
    modal.className = 'tf-dup-modal'
    modal.id = 'tfDupModal'
    modal.innerHTML = `
        <div class="tf-dup-card">
            <div class="tf-dup-header"><h4>Resolver duplicado: ${m.titular}</h4></div>
            <div class="tf-dup-body">
                <p style="font-size:12px;color:var(--text-2);margin-bottom:16px;">El más avanzado es: <strong style="color:var(--purple-light);">${moreAdvanced}</strong> (${moreAdvanced === 'CRM' ? existingStage : tfStage})</p>
                <div class="tf-dup-compare">
                    <div class="tf-dup-side">
                        <h5>📥 Typeform</h5>
                        ${fields.map(f => `<div class="tf-dup-row ${f.tf !== f.crm ? 'diff' : ''}"><span class="label">${f.label}</span><span class="val">${f.tf}</span></div>`).join('')}
                    </div>
                    <div class="tf-dup-side">
                        <h5>📋 CRM Existente</h5>
                        ${fields.map(f => `<div class="tf-dup-row ${f.tf !== f.crm ? 'diff' : ''}"><span class="label">${f.label}</span><span class="val">${f.crm}</span></div>`).join('')}
                    </div>
                </div>
            </div>
            <div class="tf-dup-actions">
                <button class="btn btn-sm btn-ghost" onclick="closeTfDupModal()">Cancelar</button>
                <button class="btn btn-sm btn-primary" onclick="resolveTfDuplicate(${idx}, 'keep_advanced')" title="Mantener el lead más avanzado">Conservar más avanzado</button>
                <button class="btn btn-sm btn-secondary" onclick="resolveTfDuplicate(${idx}, 'keep_crm')" title="Ignorar Typeform, mantener CRM">Conservar CRM</button>
                <button class="btn btn-sm btn-warning" onclick="resolveTfDuplicate(${idx}, 'keep_tf')" title="Reemplazar CRM con Typeform">Conservar Typeform</button>
                <button class="btn btn-sm btn-success" onclick="resolveTfDuplicate(${idx}, 'merge')" title="Fusionar: etapa más avanzada + datos combinados">Fusionar</button>
            </div>
        </div>`
    document.body.appendChild(modal)
}

function closeTfDupModal() {
    const modal = document.getElementById('tfDupModal')
    if (modal) modal.remove()
}

function resolveTfDuplicate(idx, action) {
    const m = tfImportData.mappedLeads[idx]
    m.resolved = true
    m.duplicate.resolution = action

    if (action === 'keep_crm') {
        m.selected = false // Don't import
    } else if (action === 'keep_advanced') {
        const existing = m.duplicate.existingLead
        const existingOrder = TF_STAGE_ORDER[existing.stage] || 0
        const tfOrder = TF_STAGE_ORDER[m.stage] || 0
        if (existingOrder >= tfOrder) {
            m.selected = false // CRM is more advanced, skip Typeform
            m.duplicate.resolution = 'keep_crm'
        } else {
            m.duplicate.resolution = 'keep_tf' // Typeform is more advanced
        }
    }

    closeTfDupModal()
    showTfWizard(2)
}

function resolveAllDuplicates() {
    if (!tfImportData) return
    tfImportData.mappedLeads.forEach((m) => {
        if (m.status === 'duplicate' && !m.resolved) {
            m.resolved = true
            m.duplicate.resolution = 'merge'
        }
    })
    showTfWizard(2)
}

function executeTfImport() {
    if (!tfImportData) return
    const { leads, clients, historico, team } = store

    window.saveState('importar Typeform')

    const ml = tfImportData.mappedLeads
    const selected = ml.filter(m => m.selected && m.status !== 'skip')
    const defaultResp = team[0]?.nombre || 'Sara'
    const results = { created: 0, merged: 0, lost: 0, skipped: 0, errors: 0, log: [] }

    selected.forEach((m, idx) => {
        try {
            if (m.status === 'lost') {
                const id = 'tf_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5)
                const clientKey = m.phone || ('name:' + m.titular.toLowerCase())

                if (!clients[clientKey]) {
                    clients[clientKey] = { titular: m.titular, contacto: m.titular, email: m.email, phone: m.phone, referido: null, trips: [], createdAt: new Date() }
                }

                const leadData = {
                    id, clientKey, titular: m.titular, contacto: m.titular, phone: m.phone, email: m.email,
                    type: m.type, stage: m.stage === 'no_compro' ? 'no_compro' : 'perdido', travelDate: m.travelDate, destination: m.destination,
                    totalVenta: 0, commission: 0, commission70: 0, progress: 0, responsable: defaultResp,
                    lostReason: m.lostReason, observaciones: m.observaciones, source: 'Typeform',
                    formData: m.formData || null, viajeros: m.viajeros || null, diasParque: m.diasParque || null,
                    seguimientos: m.followUps || 0, createdAt: m.submittedAt ? new Date(m.submittedAt) : new Date()
                }

                if (m.stage === 'no_compro') {
                    leads.push(leadData)
                } else {
                    historico.push(leadData)
                }

                results.lost++
                results.log.push({ action: 'lost', text: `${m.titular} → ${m.stage === 'no_compro' ? 'No Compró' : 'Histórico'} (${m.lostReason})` })

            } else if (m.status === 'duplicate' && m.resolved) {
                const existing = m.duplicate.existingLead
                const resolution = m.duplicate.resolution

                if (resolution === 'keep_crm') {
                    results.skipped++
                    results.log.push({ action: 'skipped', text: `${m.titular} → Conservado CRM existente` })
                } else if (resolution === 'keep_tf' || resolution === 'merge') {
                    // Update existing lead
                    const lead = leads.find(l => l.id === existing.id)
                    if (lead) {
                        if (resolution === 'keep_tf') {
                            lead.stage = m.stage
                            lead.progress = window.calcProgress(m.stage)
                        } else {
                            // Merge: keep more advanced stage
                            const existingOrder = TF_STAGE_ORDER[lead.stage] || 0
                            const tfOrder = TF_STAGE_ORDER[m.stage] || 0
                            if (tfOrder > existingOrder) {
                                lead.stage = m.stage
                                lead.progress = window.calcProgress(m.stage)
                            }
                        }
                        // FILL GAPS — CRM wins if it already has data
                        if (!lead.email && m.email) lead.email = m.email
                        if (!lead.phone && m.phone) lead.phone = m.phone
                        if (!lead.travelDate && m.travelDate) lead.travelDate = m.travelDate
                        if (!lead.destination && m.destination) lead.destination = m.destination
                        if (!lead.type && m.type) lead.type = m.type
                        if (!lead.viajeros && m.viajeros) lead.viajeros = m.viajeros
                        if (!lead.diasParque && m.diasParque) lead.diasParque = m.diasParque
                        // Typeform WINS on form data (always fresher) + observaciones
                        if (m.formData) lead.formData = { ...(lead.formData || {}), ...m.formData }
                        if (m.observaciones && !lead.observaciones) lead.observaciones = m.observaciones
                        lead.seguimientos = Math.max(lead.seguimientos || 0, m.followUps || 0)
                        lead.source = lead.source || 'Typeform'
                        window.syncLeadToSupabase(lead)
                    }
                    results.merged++
                    results.log.push({ action: 'merged', text: `${m.titular} → ${resolution === 'keep_tf' ? 'Reemplazado con Typeform' : 'Fusionado'} (${STAGES.find(s => s.id === (lead?.stage || m.stage))?.name || m.stage})` })
                }

            } else {
                // New lead — create client + lead
                const id = 'tf_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5)
                const clientKey = m.phone || ('name:' + m.titular.toLowerCase())

                if (!clients[clientKey]) {
                    clients[clientKey] = { titular: m.titular, contacto: m.titular, email: m.email, phone: m.phone, referido: null, trips: [], createdAt: new Date() }
                }

                const newLead = {
                    id, clientKey, titular: m.titular, contacto: m.titular, phone: m.phone, email: m.email,
                    type: m.type, stage: m.stage, travelDate: m.travelDate, destination: m.destination,
                    totalVenta: 0, commission: 0, commission70: 0,
                    abono: 0, abonado: 0, fechaAbono: null, fechaPagoFinal: null,
                    progress: window.calcProgress(m.stage), responsable: defaultResp,
                    observaciones: m.observaciones, source: 'Typeform',
                    formData: m.formData || null,
                    viajeros: m.viajeros || null,
                    diasParque: m.diasParque || null,
                    seguimientos: m.followUps || 0,
                    createdAt: m.submittedAt ? new Date(m.submittedAt) : new Date(),
                    comentarios: m.observaciones ? [{ id: 'import_' + Date.now() + '_' + idx, texto: '📋 Importado de Typeform:\n' + m.observaciones, autor: 'Sistema', fecha: new Date().toISOString() }] : []
                }

                clients[clientKey].trips.push({ ...newLead })
                leads.push(newLead)

                results.created++
                results.log.push({ action: 'created', text: `${m.titular} → ${STAGES.find(s => s.id === m.stage)?.name || m.stage}${m.followUps > 0 ? ` (${m.followUps} seguimientos)` : ''}` })
            }
        } catch (err) {
            console.error('TF import error for', m.titular, err)
            results.errors++
            results.log.push({ action: 'skipped', text: `${m.titular} → Error: ${err.message}` })
        }
    })

    // Count skipped
    results.skipped += ml.filter(m => !m.selected || m.status === 'skip').length

    tfImportData._results = results
    window.renderAll()
    window.syncBulkImportToSupabase()
    window.toast(`Typeform: ${results.created} creados, ${results.merged} fusionados, ${results.lost} histórico`, 'success')
    showTfWizard(4)
}

function closeTfWizard() {
    const overlay = document.getElementById('tfWizardOverlay')
    if (overlay) overlay.remove()
    tfImportData = null
}

Object.assign(window, {
    detectTfFormType,
    detectTfColumnsCruceros,
    mapTfRowsCruceros,
    detectTfColumnsHoteles,
    mapTfRowsHoteles,
    detectTfColumnsExplorando,
    mapTfRowsExplorando,
    detectTfColumns,
    mapTfRows,
    detectTfDuplicates,
    handleTypeformFile,
    applyTfFormType,
    showTfFormTypeSelector,
    selectTfFormType,
    showTfWizard,
    tfToggleAll,
    tfToggleRow,
    tfChangeStage,
    openTfDuplicateModal,
    closeTfDupModal,
    resolveTfDuplicate,
    resolveAllDuplicates,
    executeTfImport,
    closeTfWizard
})
